module.exports = __webpack_public_path__ + "static/media/2_Proceso_de_Jubilacion.a4daadbb.mp3";